import { styled } from '@creditas/stylitas'

const Wrapper = styled.div`
  height: 24px;
  padding: 4px 0;
`

export { Wrapper }
